// เหตุการณ์เฉพาะตัวของสัตว์เลื้อยคลาน สัตว์สะเทินน้ำสะเทินบก และปลาที่มีชื่อเสียง (ดู signature.ts)

import type { GameEvent } from "../../engine/types";
import { sig } from "./signature";

const ADULT = ["adult", "old"] as const;

export const SIGNATURE_REPTILE_FISH_EVENTS: readonly GameEvent[] = [
  // ---------- สัตว์เลื้อยคลาน ----------
  sig("Ophiophagus hannah", "king_cobra_nest", {
    stageTags: ADULT,
    text: "ถึงเวลาวางไข่ คุณใช้ลำตัวกวาดใบไม้แห้งมากองรวมกันเป็นเนิน",
    fact: "งูจงอางเป็นงูชนิดเดียวที่สร้างรังจากกองใบไม้ให้ไข่ และตัวเมียขดตัวเฝ้ารังอยู่หลายสัปดาห์",
    choices: [
      { label: "ขดตัวเฝ้ารังไว้", outcomes: [{ chance: 1, text: "ไม่มีสัตว์ตัวไหนกล้าเข้าใกล้รังของงูจงอาง", effects: { fullness: -20, safety: 10 } }] },
      { label: "ออกไปล่างูตัวอื่นกินก่อน", outcomes: [{ chance: 1, text: "คุณกลืนงูสิงได้ทั้งตัว แต่ระหว่างนั้นตะกวดมาขโมยไข่ไปบางฟอง", effects: { fullness: 30, safety: -5 } }] },
    ],
  }),
  sig("Malayopython reticulatus", "python_ambush", {
    stageTags: ADULT,
    text: "คุณขดตัวนิ่งอยู่ริมลำธาร หมูป่าตัวหนึ่งเดินลงมากินน้ำ",
    fact: "งูเหลือมเป็นงูที่ยาวที่สุดในโลก ตัวใหญ่ยาวได้เกิน 6 เมตร หลังกินเหยื่อตัวใหญ่แล้วอยู่ได้หลายเดือนโดยไม่ต้องกินอะไรอีก",
    choices: [
      {
        label: "ฉกแล้วรัด",
        outcomes: [
          { chance: 0.65, text: "คุณรัดเหยื่อจนหมดลมหายใจแล้วกลืนทั้งตัว อิ่มไปอีกหลายเดือน", effects: { fullness: 50 } },
          { chance: 0.35, text: "เขี้ยวหมูป่าฉีกลำตัวคุณเป็นแผลยาว", effects: { health: -25, cause: "accident" } },
        ],
      },
      { label: "รอเหยื่อที่เล็กกว่า", outcomes: [{ chance: 1, text: "หนูพุกตัวอ้วนเดินมาแทน", effects: { fullness: 15 } }] },
    ],
  }),
  sig("Naja kaouthia", "cobra_hood", {
    text: "สุนัขบ้านตัวหนึ่งเห่าใส่คุณไม่หยุด",
    fact: "งูเห่าแผ่แม่เบี้ยและขู่ฟ่อเพื่อเตือนก่อนจะฉก ลายวงกลมวงเดียวด้านหลังแม่เบี้ยทำให้ได้ชื่อภาษาอังกฤษว่า monocled cobra",
    choices: [
      { label: "ชูหัวแผ่แม่เบี้ยขู่", outcomes: [{ chance: 1, text: "สุนัขถอยไปเอง คุณไม่ต้องเสียพิษเลย", effects: { safety: 10 } }] },
      {
        label: "เลื้อยหนีเข้ากองไม้",
        outcomes: [
          { chance: 0.7, text: "คุณหายเข้าไปในกองไม้ได้", effects: { safety: 5 } },
          { chance: 0.3, text: "สุนัขงับโดนหางก่อนคุณจะมุดเข้าไปได้", effects: { health: -20, cause: "predator" } },
        ],
      },
    ],
  }),
  sig("Trimeresurus albolabris", "pit_viper_heat", {
    text: "กลางคืนมืดสนิท แต่คุณรับรู้ได้ถึงไออุ่นของหนูที่กำลังเดินมาตามกิ่งไม้",
    fact: "งูเขียวหางไหม้มีอวัยวะรับความร้อนเป็นแอ่งระหว่างตากับจมูก จึงรับรู้ไออุ่นของเหยื่อได้แม้ในที่มืดสนิท",
    choices: [
      { label: "ฉกตามไออุ่น", outcomes: [{ chance: 1, text: "การฉกแม่นยำแม้จะมองไม่เห็น", effects: { fullness: 25 } }] },
      { label: "อยู่นิ่งๆ พรางตัวต่อ", outcomes: [{ chance: 1, text: "สีเขียวทำให้คุณกลืนไปกับใบไม้ นกเดินผ่านไปโดยไม่เห็น", effects: { safety: 10 } }] },
    ],
  }),
  sig("Varanus salvator", "water_monitor_dive", {
    text: "คนกลุ่มหนึ่งเดินถือไม้มาทางคุณที่ริมคลอง",
    fact: "เหี้ยว่ายน้ำเก่งและกลั้นหายใจดำน้ำได้นานราว 30 นาที เหี้ยในกรุงเทพฯ อาศัยอยู่ในสวนสาธารณะและคูคลองกลางเมือง",
    choices: [
      { label: "ดำน้ำหนี", outcomes: [{ chance: 1, text: "คุณหายลงไปใต้น้ำนานจนพวกเขาเลิกรอ", effects: { safety: 10 } }] },
      {
        label: "ยืนขู่ฟ่อ",
        outcomes: [
          { chance: 0.5, text: "พวกเขาตกใจถอยไป", effects: { safety: 5 } },
          { chance: 0.5, text: "ไม้ฟาดโดนหลังคุณก่อนจะหนีลงน้ำ", effects: { health: -20, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Gekko gecko", "tokay_call", {
    stageTags: ADULT,
    text: "ฤดูผสมพันธุ์มาถึง คุณเกาะอยู่บนผนังบ้านกลางดึก",
    fact: "ตุ๊กแกเกาะผนังได้ด้วยขนเล็กจิ๋วนับล้านเส้นใต้นิ้วที่ยึดพื้นผิวด้วยแรงแวนเดอร์วาลส์ และตัวผู้ส่งเสียง 'ตุ๊กแก' ดังเพื่อเรียกตัวเมีย",
    choices: [
      { label: "ร้อง ตุ๊กแก! ตุ๊กแก! ให้ดังที่สุด", outcomes: [{ chance: 1, text: "ตัวเมียบนบ้านข้างๆ ได้ยินเสียงของคุณ", effects: { addFlags: ["has_mate"] } }] },
      { label: "เงียบไว้แล้วล่าแมลงใต้หลอดไฟ", outcomes: [{ chance: 1, text: "แมลงเม่าบินมาเล่นไฟเต็มไปหมด", effects: { fullness: 25 } }] },
    ],
  }),
  sig("Hemidactylus frenatus", "gecko_tail_drop", {
    text: "แมวกระโจนตะปบโดนหางคุณบนผนังห้องครัว",
    fact: "จิ้งจกสลัดหางทิ้งได้เมื่อถูกจับ หางที่หลุดยังดิ้นต่อไปหลอกนักล่า และงอกหางใหม่ขึ้นมาแทนได้",
    choices: [
      { label: "สลัดหางทิ้ง", outcomes: [{ chance: 1, text: "แมวสนใจหางที่ดิ้นอยู่ คุณวิ่งหนีขึ้นเพดานได้ หางใหม่จะค่อยๆ งอกขึ้นมา", effects: { health: -5, fullness: -10, safety: 5 } }] },
      {
        label: "ดิ้นสุดแรง",
        outcomes: [
          { chance: 0.3, text: "คุณดิ้นหลุดมาได้พร้อมหางครบ", effects: { safety: 5 } },
          { chance: 0.7, text: "แมวกดคุณไว้แน่นจนคุณต้องสลัดหางหลุดอยู่ดี และได้แผลเพิ่มอีก", effects: { health: -35, cause: "predator" } },
        ],
      },
    ],
  }),
  sig("Calotes versicolor", "garden_lizard_red", {
    stageTags: ADULT,
    text: "ฤดูผสมพันธุ์มาถึง หัวและคอของคุณเริ่มเปลี่ยนเป็นสีแดงสด",
    fact: "กิ้งก่าหัวแดงตัวผู้เปลี่ยนหัวและคอเป็นสีแดงสดในฤดูผสมพันธุ์ เพื่ออวดตัวเมียและขู่คู่แข่ง",
    choices: [
      { label: "ขึ้นไปผงกหัวโชว์บนรั้ว", outcomes: [{ chance: 1, text: "ตัวเมียเห็นสีแดงของคุณ แต่เหยี่ยวก็เห็นด้วย คุณหนีลงพุ่มไม้ทัน", effects: { addFlags: ["has_mate"], safety: -10 } }] },
      { label: "หลบหากินเงียบๆ", outcomes: [{ chance: 1, text: "ปลอดภัยดี ได้กินมดและตั๊กแตน", effects: { fullness: 20 } }] },
    ],
  }),
  sig("Crocodylus porosus", "saltie_temperature", {
    stageTags: ADULT,
    text: "คุณกองใบไม้และโคลนเป็นเนินรังริมแม่น้ำ แล้ววางไข่ไว้ข้างใน",
    fact: "อุณหภูมิในรังเป็นตัวกำหนดว่าลูกจระเข้จะเป็นเพศผู้หรือเพศเมีย แม่จระเข้เฝ้ารังและอมลูกที่เพิ่งฟักไว้ในปากอย่างเบามือเพื่อพาลงน้ำ",
    choices: [
      { label: "เฝ้ารังอยู่ใกล้ๆ", outcomes: [{ chance: 1, text: "เหี้ยที่มาขุดรังถูกคุณไล่ไป", effects: { fullness: -15, safety: 10 } }] },
      { label: "ออกไปล่าในแม่น้ำ", outcomes: [{ chance: 1, text: "คุณได้ปลาตัวใหญ่ แต่กลับมาเห็นรังถูกขุดไปบางส่วน", effects: { fullness: 30, safety: -5 } }] },
    ],
  }),
  sig("Crocodylus siamensis", "siamese_croc_rare", {
    text: "คุณว่ายสำรวจหนองน้ำ แต่ไม่เจอจระเข้ตัวอื่นเลยมาหลายเดือนแล้ว",
    fact: "จระเข้น้ำจืดเคยพบทั่วภาคกลางของไทย แต่ปัจจุบันเป็นสัตว์ใกล้สูญพันธุ์อย่างยิ่ง ในธรรมชาติเหลืออยู่น้อยมาก แม้ในฟาร์มจะมีเป็นจำนวนมาก",
    choices: [
      {
        label: "ว่ายไปหาหนองน้ำอื่น",
        outcomes: [
          { chance: 0.4, text: "ในที่สุดคุณก็เจอจระเข้อีกตัวในหนองน้ำห่างไกล", effects: { fullness: -15, move: "far", addFlags: ["has_mate"] } },
          { chance: 0.6, text: "หนองน้ำที่เจอถูกถมเป็นนาข้าวไปแล้ว", effects: { fullness: -20, move: "near" } },
        ],
      },
      { label: "อยู่ที่หนองน้ำเดิม", outcomes: [{ chance: 1, text: "ปลามีให้กินพอ แต่คุณยังคงอยู่ตัวเดียว", effects: { fullness: 15 } }] },
    ],
  }),
  sig("Crocodylus niloticus", "nile_croc_crossing", {
    stageTags: ADULT,
    text: "ฝูงวิลเดอบีสต์นับพันตัวรวมตัวกันอยู่ริมตลิ่ง เตรียมกระโดดข้ามแม่น้ำ",
    fact: "จระเข้แม่น้ำไนล์ดักรอวิลเดอบีสต์ที่ข้ามแม่น้ำมาราทุกปี และกินเหยื่อมื้อใหญ่ไปแล้วอยู่ได้นานหลายเดือน",
    choices: [
      {
        label: "ซุ่มรอที่จุดข้าม",
        outcomes: [
          { chance: 0.6, text: "คุณลากวิลเดอบีสต์ลงน้ำได้ตัวหนึ่ง", effects: { fullness: 50 } },
          { chance: 0.4, text: "ฝูงวิ่งข้ามกันอลหม่าน กีบเท้าเหยียบหัวคุณ", effects: { health: -25, cause: "accident" } },
        ],
      },
      { label: "รอกินตัวที่จมน้ำทีหลัง", outcomes: [{ chance: 1, text: "มีซากลอยมาให้กินโดยไม่ต้องเสี่ยง", effects: { fullness: 30 } }] },
    ],
  }),
  sig("Alligator mississippiensis", "gator_hole", {
    stageTags: ADULT,
    text: "หน้าแล้งมาถึง บึงเริ่มแห้ง",
    fact: "อัลลิเกเตอร์อเมริกันใช้ปากและหางขุดแอ่งน้ำลึกในหน้าแล้ง แอ่งนี้กลายเป็นแหล่งน้ำให้ปลา นก และสัตว์อื่นในบึงรอดหน้าแล้งไปด้วย",
    choices: [
      { label: "ขุดแอ่งน้ำให้ลึกขึ้น", outcomes: [{ chance: 1, text: "ปลาและสัตว์อื่นมารวมกันในแอ่งของคุณ อาหารมาถึงปากเอง", effects: { fullness: 30 } }] },
      { label: "ย้ายไปหาบึงที่ยังมีน้ำ", outcomes: [{ chance: 1, text: "คุณคลานไปไกลบนบก", effects: { fullness: -15, move: "near" } }] },
    ],
  }),
  sig("Eunectes murinus", "anaconda_water", {
    stageTags: ADULT,
    text: "คาปิบาราลงมากินน้ำห่างจากคุณไม่กี่เมตร คุณอยู่ใต้น้ำเห็นแค่ตาและจมูก",
    fact: "งูอนาคอนดาเขียวเป็นงูที่หนักที่สุดในโลก ใช้ชีวิตส่วนใหญ่ในน้ำ และตาและจมูกอยู่ด้านบนของหัวจึงซุ่มอยู่ใต้น้ำได้",
    choices: [
      {
        label: "พุ่งรัดจากใต้น้ำ",
        outcomes: [
          { chance: 0.6, text: "เหยื่อถูกดึงลงน้ำ คุณได้อาหารมื้อใหญ่", effects: { fullness: 50 } },
          { chance: 0.4, text: "คาปิบาราสะบัดหลุดและส่งเสียงเตือนทั้งฝูง", effects: { fullness: -5 } },
        ],
      },
      { label: "รออยู่เฉยๆ", outcomes: [{ chance: 1, text: "ไม่มีอะไรเข้ามาใกล้พอ คุณประหยัดพลังงานไว้", effects: { fullness: -5 } }] },
    ],
  }),
  sig("Dendroaspis polylepis", "black_mamba_mouth", {
    text: "พังพอนตัวหนึ่งเดินวนเข้ามาใกล้โพรงที่คุณพัก",
    fact: "ภายในปากของงูแมมบาดำเป็นสีดำสนิท จึงได้ชื่อนี้ ส่วนลำตัวจริงๆ เป็นสีเทาหรือน้ำตาล และเป็นงูที่เลื้อยได้เร็วที่สุดชนิดหนึ่ง",
    choices: [
      {
        label: "ชูหัวอ้าปากสีดำขู่",
        outcomes: [
          { chance: 0.6, text: "พังพอนชะงักแล้วเดินหนีไป", effects: { safety: 10 } },
          { chance: 0.4, text: "พังพอนว่องไวหลบการฉกและกัดคุณ", effects: { health: -30, cause: "predator" } },
        ],
      },
      { label: "เลื้อยหนีด้วยความเร็วสูง", outcomes: [{ chance: 1, text: "ไม่มีอะไรตามคุณทัน", effects: { fullness: -10, safety: 5 } }] },
    ],
  }),
  sig("Chelonia mydas", "green_turtle_seagrass", {
    stageTags: ADULT,
    text: "คุณเจอแนวหญ้าทะเลเขียวขจีในอ่าวตื้น",
    fact: "เต่าตนุตัวโตกินหญ้าทะเลและสาหร่ายเป็นหลัก ไขมันในตัวจึงมีสีเขียว จนได้ชื่อภาษาอังกฤษว่า green turtle",
    choices: [
      { label: "เล็มหญ้าทะเลจนอิ่ม", outcomes: [{ chance: 1, text: "หญ้าทะเลอุดมสมบูรณ์ คุณกินได้ทั้งวัน", effects: { fullness: 30 } }] },
      {
        label: "ว่ายไปหาแนวปะการังที่มีสาหร่าย",
        outcomes: [
          { chance: 0.7, text: "สาหร่ายบนปะการังก็อร่อยไม่แพ้กัน", effects: { fullness: 20 } },
          { chance: 0.3, text: "ระหว่างทางคุณติดอวนประมง แต่ดิ้นหลุดออกมาได้", effects: { health: -20, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Dermochelys coriacea", "leatherback_plastic", {
    text: "คุณเห็นอะไรใสๆ ลอยพลิ้วอยู่ในน้ำ ดูเหมือนแมงกะพรุน",
    fact: "เต่ามะเฟืองดำน้ำได้ลึกกว่า 1,000 เมตรและกินแมงกะพรุนเป็นอาหารหลัก ถุงพลาสติกในทะเลจึงอันตรายมาก เพราะหน้าตาคล้ายแมงกะพรุน",
    choices: [
      {
        label: "งับเลย",
        outcomes: [
          { chance: 0.5, text: "เป็นแมงกะพรุนจริงๆ อร่อยดี", effects: { fullness: 20 } },
          { chance: 0.5, text: "มันคือถุงพลาสติก ติดอยู่ในท้องจนคุณรู้สึกไม่สบาย", effects: { health: -25, fullness: -10, cause: "human" } },
        ],
      },
      { label: "ดำลงไปหาแมงกะพรุนในที่ลึก", outcomes: [{ chance: 1, text: "ที่ความลึกหลายร้อยเมตร มีแมงกะพรุนตัวจริงเต็มไปหมด", effects: { fullness: 25 } }] },
    ],
  }),
  // ---------- สัตว์สะเทินน้ำสะเทินบก ----------
  sig("Hoplobatrachus rugulosus", "rice_frog_chorus", {
    stageTags: ADULT,
    text: "ฝนแรกตกหนักทั้งคืน นาข้าวกลายเป็นแอ่งน้ำกว้าง",
    fact: "กบนาตัวผู้ร้องเรียกตัวเมียหลังฝนตกหนัก ถุงเสียงข้างแก้มพองเป็นลูกโป่ง เสียงประสานจากกบนับร้อยตัวดังไปทั่วทุ่ง",
    choices: [
      { label: "ร้องประสานเสียงกับตัวอื่นๆ", outcomes: [{ chance: 1, text: "ตัวเมียเลือกเสียงของคุณที่ดังและนานที่สุด", effects: { fullness: -10, addFlags: ["has_mate"] } }] },
      {
        label: "หลบอยู่ใต้กอข้าว",
        outcomes: [
          { chance: 0.6, text: "คืนนี้ปลอดภัย คนหาจับกบเดินผ่านไป", effects: { safety: 10 } },
          { chance: 0.4, text: "ไฟฉายของคนหาจับกบส่องมาเจอคุณ คุณกระโดดหนีลงน้ำ", effects: { health: -15, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Duttaphrynus melanostictus", "toad_poison", {
    text: "สุนัขตัวหนึ่งเข้ามาดม แล้วอ้าปากจะงับคุณ",
    fact: "คางคกบ้านมีต่อมพิษคู่ใหญ่หลังตา ปล่อยยางสีขาวที่เป็นพิษต่อสัตว์ที่กัดมัน",
    choices: [
      { label: "พองตัวแล้วปล่อยยางพิษ", outcomes: [{ chance: 1, text: "สุนัขคายคุณออกมาพร้อมน้ำลายฟูมปาก มันจะไม่ลองอีกแล้ว", effects: { health: -10, safety: 15 } }] },
      {
        label: "กระโดดหนี",
        outcomes: [
          { chance: 0.5, text: "คุณหลบเข้าซอกหินได้", effects: { safety: 5 } },
          { chance: 0.5, text: "คุณกระโดดได้ไม่ไกล สุนัขงับขาคุณไว้", effects: { health: -25, cause: "predator" } },
        ],
      },
    ],
  }),
  // ---------- ปลา ----------
  sig("Betta splendens", "betta_bubble_nest", {
    stageTags: ADULT,
    text: "คุณเจอมุมสงบใต้ใบบัวในนาข้าว น้ำนิ่งไม่มีคลื่น",
    fact: "ปลากัดตัวผู้ก่อหวอดจากฟองอากาศผสมน้ำลายใต้ผิวน้ำ แล้วอมไข่ไปพ่นติดไว้ในหวอดและเฝ้าจนลูกปลาฟัก",
    choices: [
      { label: "ก่อหวอดแล้วกางครีบเรียกตัวเมีย", outcomes: [{ chance: 1, text: "หวอดฟองใหญ่ล่อตัวเมียมาวางไข่ คุณเก็บไข่ไปพ่นติดหวอดทีละฟอง", effects: { fullness: -10, addFlags: ["has_mate"] } }] },
      {
        label: "พองเหงือกขู่ปลากัดตัวอื่น",
        outcomes: [
          { chance: 0.6, text: "อีกตัวหุบครีบหนีไป นาข้าวมุมนี้เป็นของคุณ", effects: { safety: 10 } },
          { chance: 0.4, text: "การต่อสู้ทำให้ครีบของคุณขาดวิ่น", effects: { health: -20, cause: "accident" } },
        ],
      },
    ],
  }),
  sig("Pangasianodon gigas", "giant_catfish_algae", {
    stageTags: ADULT,
    text: "คุณว่ายผ่านแก่งหินในแม่น้ำโขง ผิวหินมีตะไคร่และสาหร่ายเกาะหนา",
    fact: "ปลาบึกเป็นปลาน้ำจืดที่ใหญ่ที่สุดชนิดหนึ่งของโลก ตัวที่บันทึกไว้หนักราว 293 กก. แต่ตัวโตกินแต่สาหร่ายและพืชน้ำ และไม่มีฟัน",
    choices: [
      { label: "เล็มสาหร่ายบนแก่งหิน", outcomes: [{ chance: 1, text: "สาหร่ายอุดมสมบูรณ์ คุณกินได้เต็มที่", effects: { fullness: 30 } }] },
      {
        label: "ว่ายผ่านช่วงน้ำเชี่ยว",
        outcomes: [
          { chance: 0.6, text: "ร่างใหญ่ของคุณฝ่ากระแสน้ำไปได้สบาย", effects: { move: "near" } },
          { chance: 0.4, text: "คุณติดเบ็ดราวของชาวประมงแต่ดิ้นหลุด", effects: { health: -20, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Rhincodon typus", "whale_shark_filter", {
    text: "แพลงก์ตอนและไข่ปลาลอยหนาแน่นอยู่ใกล้ผิวน้ำ เรือนักดำน้ำลำหนึ่งจอดอยู่ใกล้ๆ",
    fact: "ฉลามวาฬเป็นปลาที่ใหญ่ที่สุดในโลก แต่กินแพลงก์ตอนตัวเล็กๆ ด้วยการกรองน้ำ และลายจุดของแต่ละตัวไม่ซ้ำกัน นักวิจัยจึงระบุตัวได้จากภาพถ่าย",
    choices: [
      { label: "อ้าปากกว้างกรองแพลงก์ตอน", outcomes: [{ chance: 1, text: "นักดำน้ำว่ายตามถ่ายรูปลายจุดของคุณ ส่วนคุณกินจนอิ่ม", effects: { fullness: 35 } }] },
      {
        label: "ว่ายหนีเรือลงที่ลึก",
        outcomes: [
          { chance: 0.7, text: "คุณดำลงไปหลายร้อยเมตร ปลอดภัยจากใบพัดเรือ", effects: { fullness: -5, safety: 10 } },
          { chance: 0.3, text: "ใบพัดเรือเฉี่ยวครีบหลังเป็นแผล", effects: { health: -20, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Carcharodon carcharias", "white_shark_sense", {
    stageTags: ADULT,
    text: "คุณว่ายช้าๆ ใต้แนวสาหร่ายเคลป์ รับรู้ถึงอะไรบางอย่างที่เต้นเป็นจังหวะอยู่ใกล้ๆ",
    fact: "ฉลามขาวรับรู้สนามไฟฟ้าอ่อนๆ จากการเต้นของหัวใจและกล้ามเนื้อของเหยื่อได้ด้วยอวัยวะพิเศษใต้จมูก",
    choices: [
      {
        label: "พุ่งขึ้นจากด้านล่าง",
        outcomes: [
          { chance: 0.6, text: "แมวน้ำไม่ทันเห็นคุณที่พุ่งขึ้นมาจากความมืดใต้น้ำ", effects: { fullness: 40 } },
          { chance: 0.4, text: "เป็นแค่กระดานโต้คลื่น คุณคายทิ้งแล้วว่ายจากไป", effects: { fullness: -10 } },
        ],
      },
      { label: "ตามกลิ่นซากวาฬไปแทน", outcomes: [{ chance: 1, text: "ซากวาฬลอยอยู่กลางทะเล อาหารพอสำหรับฉลามหลายตัว", effects: { fullness: 35, move: "far" } }] },
    ],
  }),
  sig("Galeocerdo cuvier", "tiger_shark_eats_anything", {
    text: "มีกล่องโลหะสีสดลอยมาจากเรือที่ผ่านไป",
    fact: "ฉลามเสือกินแทบทุกอย่างที่เจอ เคยพบทั้งป้ายทะเบียนรถและยางรถยนต์ในกระเพาะ แต่อาหารหลักคือปลา เต่าทะเล และนกทะเล",
    choices: [
      { label: "ลองงับดู", outcomes: [{ chance: 1, text: "ไม่ใช่อาหาร แต่คุณก็กลืนลงไปแล้ว", effects: { health: -10 } }] },
      { label: "ไล่ตามเต่าทะเลแถวนั้นแทน", outcomes: [{ chance: 1, text: "ฟันหยักของคุณกัดกระดองเต่าทะลุได้", effects: { fullness: 35 } }] },
    ],
  }),
  sig("Channa striata", "snakehead_fry_ball", {
    stageTags: ADULT,
    text: "ลูกปลาสีแดงส้มนับร้อยตัวว่ายเป็นก้อนอยู่ใกล้ผิวน้ำ นกกระเต็นเกาะอยู่บนกิ่งไม้เหนือน้ำ",
    fact: "พ่อแม่ปลาช่อนเฝ้าฝูงลูกปลาสีแดงส้มที่ว่ายรวมเป็นก้อนอยู่ใกล้ผิวน้ำ และพุ่งเข้าใส่อะไรก็ตามที่เข้าใกล้",
    choices: [
      { label: "ว่ายวนเฝ้าฝูงลูกไว้", outcomes: [{ chance: 1, text: "นกกระเต็นเห็นคุณแล้วไม่กล้าโฉบ", effects: { fullness: -10, safety: 10 } }] },
      { label: "ออกไปหาอาหาร", outcomes: [{ chance: 1, text: "คุณได้กบมาตัวหนึ่ง แต่ลูกปลาหายไปบางส่วน", effects: { fullness: 25, safety: -5 } }] },
    ],
  }),
  sig("Anabas testudineus", "climbing_perch_walk", {
    text: "แอ่งน้ำที่คุณอยู่กำลังจะแห้ง มีคูน้ำอีกแห่งอยู่ห่างออกไปไม่กี่เมตร",
    fact: "ปลาหมอหายใจจากอากาศได้ และใช้กระดูกแก้มกับครีบดันตัวคืบคลานข้ามพื้นดินชื้นไปหาแหล่งน้ำใหม่ได้",
    choices: [
      {
        label: "คืบคลานข้ามดินไปหาคูน้ำ",
        outcomes: [
          { chance: 0.75, text: "คุณไปถึงคูน้ำที่ลึกกว่าได้สำเร็จ", effects: { fullness: -10, move: "near" } },
          { chance: 0.25, text: "นกกาเห็นคุณดิ้นอยู่บนดิน", effects: { health: -25, cause: "predator" } },
        ],
      },
      { label: "ฝังตัวในโคลนรอฝน", outcomes: [{ chance: 1, text: "คุณหายใจจากอากาศรอจนฝนตก", effects: { fullness: -15, safety: 5 } }] },
    ],
  }),
  sig("Oreochromis niloticus", "tilapia_mouthbrood", {
    stageTags: ADULT,
    text: "ลูกปลาของคุณเพิ่งฟักออกจากไข่ ปลาช่อนตัวใหญ่ว่ายเข้ามาใกล้",
    fact: "แม่ปลานิลอมไข่และลูกปลาไว้ในปากจนแข็งแรง ปลานิลในไทยสืบมาจากปลา 50 ตัวที่สมเด็จพระจักรพรรดิอากิฮิโตะของญี่ปุ่น ขณะยังทรงเป็นมกุฎราชกุมาร ทูลเกล้าฯ ถวายรัชกาลที่ 9 เมื่อปี 2508",
    choices: [
      { label: "อมลูกปลาไว้ในปาก", outcomes: [{ chance: 1, text: "ลูกปลาทั้งหมดปลอดภัยในปากของคุณ แม้คุณจะกินอะไรไม่ได้", effects: { fullness: -15, safety: 10 } }] },
      { label: "พุ่งเข้าไล่ปลาช่อน", outcomes: [{ chance: 1, text: "ปลาช่อนถอยไป แต่ลูกปลาบางตัวว่ายกระจายหายไป", effects: { safety: -5 } }] },
    ],
  }),
  sig("Rastrelliger brachysoma", "mackerel_closed_season", {
    text: "ต้นปีมาถึง ฝูงปลาทูว่ายเข้าหาแหล่งวางไข่ในอ่าวไทย ทะเลเงียบกว่าปกติ",
    fact: "ทุกปีช่วงกลางเดือนกุมภาพันธ์ถึงกลางเดือนพฤษภาคม ไทยปิดอ่าวไทยตอนกลางห้ามทำประมงบางประเภท เพื่อให้ปลาทูได้วางไข่และเลี้ยงตัวอ่อน",
    choices: [
      { label: "ว่ายตามฝูงไปวางไข่", outcomes: [{ chance: 1, text: "เรืออวนลากหายไปหมด ฝูงปลาทูวางไข่ได้อย่างปลอดภัย", effects: { safety: 10, addFlags: ["has_mate"] } }] },
      {
        label: "ว่ายออกไปหากินนอกเขตปิดอ่าว",
        outcomes: [
          { chance: 0.5, text: "แพลงก์ตอนนอกเขตมีเยอะ", effects: { fullness: 25 } },
          { chance: 0.5, text: "นอกเขตยังมีเรืออวนลาก คุณเกือบติดอวน", effects: { health: -20, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Thunnus albacares", "tuna_warm_blood", {
    stageTags: ADULT,
    text: "ฝูงปลาซาร์ดีนอยู่ลึกลงไปในน้ำเย็น ปลาตัวอื่นว่ายช้าลงเมื่อน้ำเย็น แต่คุณไม่",
    fact: "ปลาทูน่ารักษาอุณหภูมิกล้ามเนื้อให้อุ่นกว่าน้ำรอบตัวได้ จึงว่ายเร็วและไกล และไล่ล่าในน้ำเย็นที่ลึกได้",
    choices: [
      { label: "ดำลงไปไล่ในน้ำเย็น", outcomes: [{ chance: 1, text: "กล้ามเนื้อที่อุ่นทำให้คุณเร็วกว่าเหยื่อเสมอ", effects: { fullness: 35 } }] },
      {
        label: "ไล่ฝูงปลาบนผิวน้ำ",
        outcomes: [
          { chance: 0.6, text: "ได้ปลาหลายตัว", effects: { fullness: 25 } },
          { chance: 0.4, text: "ฝูงนกทะเลที่บินวนบนผิวน้ำบอกเรือประมงว่ามีปลาทูน่าอยู่ตรงนี้", effects: { health: -20, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Pygocentrus nattereri", "piranha_school", {
    text: "นกกระสาตัวใหญ่ยืนอยู่ในน้ำตื้น จ้องมองฝูงปลาของคุณ",
    fact: "ปลาปิรันยาท้องแดงอยู่เป็นฝูงเพื่อป้องกันตัวเองจากนักล่าอย่างนก โลมาแม่น้ำ และไคแมน มากกว่าจะรวมฝูงเพื่อรุมล่า",
    choices: [
      { label: "ว่ายเข้ากลางฝูง", outcomes: [{ chance: 1, text: "ปลาที่ว่ายอยู่ขอบฝูงต่างหากที่เสี่ยง คุณปลอดภัย", effects: { safety: 10, fullness: -5 } }] },
      {
        label: "ว่ายออกไปกินซากปลาที่ลอยอยู่",
        outcomes: [
          { chance: 0.5, text: "คุณกินซากได้เต็มปาก", effects: { fullness: 25 } },
          { chance: 0.5, text: "นกกระสาจิกโดนตัวคุณ คุณดิ้นหลุดกลับลงน้ำได้แต่บาดเจ็บหนัก", effects: { health: -35, cause: "predator" } },
        ],
      },
    ],
  }),
];
